import { map, pathOr, pick } from 'ramda'
import { createSelector } from 'reselect'

import { selectUserTimezone } from '@/app/module/user/store/selectors'

const partSelectPageValue = pathOr('1', ['groups', 'list', 'data', 'page'])

const partSelectPageIds = pathOr({}, ['groups', 'list', 'data', 'pages'])

const partSelectValues = pathOr([], ['groups', 'list', 'data', 'values'])

export const selectOrdered = createSelector(partSelectPageValue, partSelectPageIds, (page, pages) =>
  pathOr([], [page], pages),
)

export const selectHeaders = () => [
  {
    title: 'Name',
    fields: ['name'],
  },
  {
    title: 'Created',
    fields: ['createdAt'],
  },
  {
    title: 'Number of contacts',
    fields: ['numberOfContacts'],
  },
]

export const partSelectPage = createSelector(selectOrdered, partSelectValues, pick)

export const selectItemConfig = createSelector(selectUserTimezone, (tz) => ({
  id: {
    type: 'hidden',
    display: 'hidden',
  },
  name: {
    type: 'text',
    display: 'text',
  },
  createdAt: {
    type: 'datetime',
    display: 'datetime',
    tz,
  },
  numberOfContacts: {
    type: 'text',
    display: 'text',
    icon: 'group',
  },
}))

const getValues =
  ({ headers }) =>
  (item) => ({
    ...headers.reduce(
      (acc, { fields }) => ({
        ...acc,
        ...pick(fields, item),
      }),
      {},
    ),
  })

export const selectPage = createSelector(selectHeaders, partSelectPage, (headers, items = {}) =>
  map(getValues({ headers }), items),
)
